import React, { useState, useEffect } from 'react';
import '../../styles/NotifyAdmin.css';

const NotifyAdmin = ({ notifications }) => {
    const [visibleNotifications, setVisibleNotifications] = useState([]);

    useEffect(() => {
        setVisibleNotifications(notifications);
    }, [notifications]);

    return (
        <div className="notify-admin-container">
            {visibleNotifications.map((notification) => (
                <div key={notification.id} className={`notify-admin ${notification.isError ? 'error' : ''}`}>
                    <p>{notification.message}</p>
                </div>
            ))}
        </div>
    );
};

export default NotifyAdmin;
